'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePublicUsageTracker = undefined;

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _usageTrackerPublic = require('usage-tracker-public');

var _events = require('conversations-visitor-ui/events.yaml');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

function makeProperties(_ref) {
  var messagesUtk = _ref.messagesUtk;

  return {
    namespace: 'conversations-visitor-ui',
    hubId: _hubspot2.default.get(),

    // HACK!!! internally, usage-tracker splits the hstc on "." and takes the second item
    hstc: '.' + messagesUtk,

    email: null,
    lang: null
  };
}

var makePublicUsageTracker = exports.makePublicUsageTracker = function makePublicUsageTracker(_ref2) {
  var messagesUtk = _ref2.messagesUtk,
      portalId = _ref2.portalId;
  return (0, _usageTrackerPublic.createTracker)({
    events: _events2.default,
    properties: makeProperties({ messagesUtk: messagesUtk, portalId: portalId })
  });
};